import React from 'react'

export default function Card(props) {
  return (
    <div style={{ padding: 16, background: 'white', borderRadius: 5, boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.1)', ...props.style }}>
        {props.children}
    </div>
  )
}
